
import defineConfig from "./defineConfig";
import baseConfig from "./baseConfig";
import qsGuoTouConfig from "./../business/businessConfig/qsVersionConfig/qsGuoTouConfig";
var getBizConfig = function getBizConfig(busiCode, userType) {
  var bizConfig = qsGuoTouConfig.$qsConfig.GUOTOU;
  var key = busiCode in bizConfig ? busiCode : busiCode + "-" + userType;
  if (bizConfig[key]) {
    bizConfig = bizConfig[key];
  } else {
    return {};
  }
  return bizConfig;
};

var getBizConfigName = function getBizConfigName(configName) {
  if (!configName) {
    configName = defineConfig.$definecfg.QSJGDM_CONST[baseConfig.$basecfg.qsVersion];
  }
  var tempName = configName;
  switch (configName) {
    case "GUOXIN":
      tempName = "GUOXIN";
      break;
    case "ZHONGTAI":
      tempName = "ZHONGTAI";
      break;
    case "":
      tempName = "";
      break;
    default:
      tempName = "BIAOZHUN";
      break;
  };
  return tempName;
};

var bizCfgObj = {
  getBizConfig: getBizConfig,
  getBizConfigName: getBizConfigName
};

var plugin = {
  install: function install(Vue) {
    Vue.bizcfg = bizCfgObj;

    Vue.prototype.$bizcfg = bizCfgObj;
  },

  $bizcfg: bizCfgObj
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/bizConfig.js
// module id = 197
// module chunks = 2